
import routerProvider from '@pankod/refine-react-router-v6'
import { useMemo } from 'react';
const { useParams: useRouterParams } = routerProvider

export const useParams = () => {
    const params = useRouterParams();

    return useMemo(() => params, [params]);
}